import { Dropdown } from "react-bootstrap";
import styles from "./keyfobcard.module.css";
import { Link } from "react-router-dom";
import { MoreVertical, Trash2 } from "react-feather";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useAuth0 } from "@auth0/auth0-react";
import { Switch } from "@mui/material";
import axios from "axios";
import { toast } from 'react-smart-toaster';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const KeyfobCard = ({ item, setDeleteModalOpen, setDeleteCardNumber, setFeyfobList, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();

    const onStatusChange = async (e) => {
        let newStatus = 0;
        if (e.target.checked) {
            newStatus = 1;
        }

        setFeyfobList(prev => {
            return prev.map(i => {
                if (i?.card_number === item?.card_number)
                    return { ...i, status: newStatus };
                return i;
            })
        });

        let url = process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs/' + item?.card_number + '/disable';
        if (e.target.checked) {
            url = process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs/' + item?.card_number + '/enable';
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        axios.put(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return <Link to={"/smart-devices/keyfobs/details/" + item?.card_number} className={`${styles.ProspectCard}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device-keyfob:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setDeleteCardNumber(item?.card_number); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>}
                {/* <Switch
                    className={`${styles.SwitchToggle}`}
                    checked={item?.status === 1}
                    onChange={(e) => onStatusChange(e)}
                    onClick={(e) => e.stopPropagation()}
                />*/}
                <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/door-key-icon.svg" className={`${styles.ProspectCardImg}`} alt="" />
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.card_name}</span>
                    </p>
                    <p className={`${styles.ProsUserName}`}>{item?.card_number}</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Type:</p>
                        <p className={`${styles.Content}`}>{item?.card_type}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Associated Lock:</p>
                        <p className={`${styles.Content}`}>
                            {item?.associated_locks?.length > 0 && <BootstrapTooltip title={(<div className={`${styles.TooltipListRow}`}>
                                {item?.associated_locks?.map((i, ind) => {
                                    return <div className={`${styles.TooltipList}`}>#{ind + 1}: {i}</div>
                                })}
                            </div>)}>
                                {item?.associated_locks[0]}
                                {item?.associated_locks?.length > 1 && <span className={`${styles.MorePropertyBU}`}>+{item?.associated_locks?.length - 1}</span>}
                            </BootstrapTooltip>}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </Link>
}

export default KeyfobCard;